export { default } from 'flows/core/pages/welcome';
